import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { createOrder } from "../apis/authApi";
import { getProduct, razorpayPayment } from "../apis/config";
import toast from "react-hot-toast";
import { initializeCart } from "../store/slices/CartSlice";

const BuyNow = () => {
  const { user } = useAuth();
  const { productId } = useParams()
  const [product, setProduct] = useState(null)
  // const cartItems = useSelector((state) => state.cart.cart);
  const dispatch = useDispatch()

  const navigate = useNavigate();

  const [addressOption, setAddressOption] = useState("new");
  const [paymentMethod, setPaymentMethod] = useState("razorpay");
  const [shippingAmount, setShippingAmount] = useState(10);

  const [selectedAddressId, setSelectedAddressId] = useState(
    user?.addresses[0]._id
  );
  const [formData, setFormData] = useState({
    street: "",
    city: "",
    pincode: "",
    state: "",
  });

  const savedAddress = {
    name: "John Doe",
    email: "john@example.com",
    address: "123 Main St",
    city: "Mumbai",
    postalCode: "400001",
    phone: "9876543210",
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const customerDetails = addressOption === "saved" ? user?.addresses.find(ad=>ad._id===selectedAddressId) : formData;
  //   const data = {
  //     customer: user._id,
  //     products: [{
  //         product:product._id,
  //         quantity:1,
  //         price:product.price,
  //         salePrice:product.salePrice
  //       }],
  //     paymentDetails:{
  //       transactionId: "",
  //       paymentMethod: paymentMethod,
  //       amount: total,
  //       taxAmount: 0,
  //       shippingAmount:10,
  //       status: "paid",
  //     },
  //     shippingAddress : customerDetails,
  //     billingAddress:customerDetails,
  //     orderStatus : [{
  //       status: 'placed' ,
  //       description: 'An order has been placed.' 
  //     }]
  //   }
  //   console.log("Order submitted:", data);

  //   createOrder(data).then(res=>{
  //     toast.success(`Order placed with ${paymentMethod.toUpperCase()} successfully!`);
  //     navigate("/success");
  //   }).catch(err=>toast.error(err?.response?.data?.message))

  // };

  const handleRazropaySubmit = async (e) => {
    e.preventDefault();

    const customerDetails =
      addressOption === "saved"
        ? user?.addresses.find((ad) => ad._id === selectedAddressId)
        : formData;

    try {
      // 1. Create Razorpay Order on Backend
      const { data: razorpayOrder } = await razorpayPayment(
        {
          amount: total + shippingAmount, // in INR (your backend will convert to paise)
        }
      );

      // 2. Razorpay Checkout Options
      const options = {
        key: "rzp_live_TcM4JRt5twhKF7", // 🔁 Replace with your Razorpay PUBLIC key
        amount: razorpayOrder.amount,
        currency: razorpayOrder.currency,
        name: "Fivea Store",
        description: "Order Payment",
        order_id: razorpayOrder.id,
        handler: async function (response) {
          // 3. On Payment Success → Create Order
          const paymentDetails = {
            transactionId: response.razorpay_payment_id,
            paymentMethod: "razorpay",
            amount: total,
            taxAmount: 0,
            shippingAmount: 10,
            status: "paid",
          };

          const orderData = {
            customer: user._id,
            products: [{
              product: product._id,
              quantity: 1,
              price: product.price,
              salePrice: product.salePrice
            }],
            paymentDetails,
            shippingAddress: customerDetails,
            billingAddress: customerDetails,
            orderStatus: [
              {
                status: "placed",
                description: "Order placed and paid via Razorpay",
              },
            ],
          };

          await createOrder(orderData);
          toast.success("Order placed successfully via Razorpay!");
          dispatch(initializeCart([]));
          navigate("/success");
        },
        prefill: {
          name: user.name,
          email: user.email,
          contact: user.phone,
        },
        notes: {
          address: customerDetails?.address || "No Address",
        },
        theme: {
          color: "#3399cc",
        },
      };

      // 4. Open Razorpay UI
      const rzp = new window.Razorpay(options);
      rzp.open();

      rzp.on("payment.failed", function (response) {
        toast.error("Payment failed. Try again.");
        console.error("Payment error", response.error);
      });
    } catch (error) {
      console.error("Order Error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user]);
  useEffect(() => {
    getProduct(productId).then(res => setProduct(res.data)).catch(err => console.log(err))
  }, [productId]);
  if (!product) {
    return null;
  }
  const total = product.salePrice * 1

  return (

    <div className="w-full px-5 md:px-10 py-10">
      <h1 className="text-2xl font-bold mb-6">Checkout</h1>
      <div className="flex flex-col md:flex-row gap-8">
        {/* Checkout Form */}
        <form
          onSubmit={handleRazropaySubmit}
          className="md:w-2/3 bg-white p-6 rounded-lg shadow"
        >
          <h2 className="text-xl font-semibold mb-4">Shipping Address</h2>

          {/* Address Option */}
          <div className="mb-4">
            <label className="mr-4">
              <input
                type="radio"
                name="addressOption"
                value="saved"
                checked={addressOption === "saved"}
                onChange={() => setAddressOption("saved")}
                className="mr-1"
              />
              Use Saved Address
            </label>
            <label>
              <input
                type="radio"
                name="addressOption"
                value="new"
                checked={addressOption === "new"}
                onChange={() => setAddressOption("new")}
                className="mr-1 ml-4"
              />
              Enter New Address
            </label>
          </div>

          {addressOption === "new" ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="street"
                placeholder="Street"
                value={formData.street}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                required
              />
              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.city}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                required
              />
              <input
                type="text"
                name="state"
                placeholder="State"
                value={formData.state}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                required
              />
              <input
                type="text"
                name="pincode"
                placeholder="Pin Code"
                value={formData.pincode}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                required
              />
              {/* <textarea
                name="address"
                placeholder="Full Address"
                value={formData.address}
                onChange={handleChange}
                className="border p-2 rounded w-full col-span-2"
                required
              /> */}
            </div>
          ) : (
            <div className="space-y-4 mt-4">
              {user?.addresses.map((addr) => (
                <label
                  key={addr._id}
                  className={`block border p-4 rounded cursor-pointer ${selectedAddressId === addr.id
                      ? "border-blue-500"
                      : "border-gray-300"
                    }`}
                >
                  <input
                    type="radio"
                    name="savedAddress"
                    value={addr._id}
                    checked={selectedAddressId === addr._id}
                    onChange={() => setSelectedAddressId(addr._id)}
                    className="mr-2"
                  />
                  <div>
                    <p>
                      {addr.street}, {addr.city} - {addr.pincode}
                    </p>
                  </div>
                </label>
              ))}
            </div>
          )}

          {/* Payment Method */}
          {/* <h2 className="text-xl font-semibold mt-8 mb-4">Payment Method</h2>
          <div className="space-y-3">

            <label className="flex items-center space-x-3 cursor-pointer border-[1px] border-gray-300 p-3">
              <input
                type="radio"
                name="paymentMethod"
                value="razorpay"
                checked={paymentMethod === "razorpay"}
                onChange={(e) => setPaymentMethod(e.target.value)}
                className="accent-primary"
              />
              <img
                src="/assets/razorpay-icon.svg"
                alt="Razorpay"
                className="w-10 h-10"
              />
              <span>Razorpay</span>
            </label>

            <label className="flex items-center space-x-3 cursor-pointer border-[1px] border-gray-300 p-3">
              <input
                type="radio"
                name="paymentMethod"
                value="cod"
                checked={paymentMethod === "cod"}
                onChange={(e) => setPaymentMethod(e.target.value)}
                className="accent-primary"
              />
              <img
                src="/assets/cod.svg"
                alt="Cash on Delivery"
                className="w-10 h-10"
              />
              <span>Cash on Delivery (COD)</span>
            </label>

            <label className="flex items-center space-x-3 cursor-pointer border-[1px] border-gray-300 p-3">
              <input
                type="radio"
                name="paymentMethod"
                value="card"
                checked={paymentMethod === "card"}
                onChange={(e) => setPaymentMethod(e.target.value)}
                className="accent-primary"
              />
              <img
                src="/assets/credit.svg"
                alt="Card Payment"
                className="w-10 h-10"
              />
              <span>Credit / Debit Card</span>
            </label>
          </div> */}

          {/* {paymentMethod === "card" && (
            <div className="mt-4 space-y-4 border p-4 rounded bg-gray-50">
              <h3 className="text-lg font-medium">Card Details</h3>
              <input
                type="text"
                name="cardNumber"
                placeholder="Card Number"
                maxLength={16}
                className="border p-2 rounded w-full"
                required
              />
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="text"
                  name="expiry"
                  placeholder="MM/YY"
                  className="border p-2 rounded w-full"
                  required
                />
                <input
                  type="text"
                  name="cvv"
                  placeholder="CVV"
                  maxLength={4}
                  className="border p-2 rounded w-full"
                  required
                />
              </div>
            </div>
          )} */}

          <button
            type="submit"
            className="mt-6 w-full bg-primary text-white py-3 rounded hover:bg-green-700"
          >
            Place Order
          </button>
        </form>

        {/* Order Summary */}
        <div className="md:w-1/3 bg-white p-6 border rounded-lg shadow h-fit">
          <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
          <ul className="divide-y mb-4">
            {/* {cartItems.map((item) => ( */}
            <li className="py-2 flex justify-between text-sm">
              <span>
                {product.name} x {1}
              </span>
              <span>₹{product.salePrice * 1}</span>
            </li>
            {/* ))} */}
          </ul>

          {/* Summary Details */}
          <div className="space-y-2 border-t pt-4 text-sm">
            <div className="flex justify-between">
              <span>Subtotal</span>
              <span>₹{total.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <span>Tax</span>
              <span>₹0.00</span>
            </div>
            <div className="flex justify-between">
              <span>Shipping</span>
              <span>₹10.00</span>
            </div>
            <div className="border-t pt-2 flex justify-between font-semibold text-base">
              <span>Total</span>
              <span>₹{(total + 10).toFixed(2)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyNow;
